var React = require('react');

function Checked (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","key":0}),React.createElement("path",{"d":"M3.3335 11.0938L8.00016 15.8333L16.6668 5","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Checked.defaultProps = {"className":"checked-icon","width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Checked;

Checked.default = Checked;
